import { WEB_URL } from "@/config/endpoints";

export function getHSNSearchBreadcrumbSchema({ keywordName, keywordSlug } = {}) {
  const itemList = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": WEB_URL,
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "HSN Codes List",
      "item": `${WEB_URL}/hsn-code/search`,
    },
  ];

  if (keywordName && keywordSlug) {
    itemList.push({
      "@type": "ListItem",
      "position": 3,
      "name": keywordName,
      "item": `${WEB_URL}/hsn-code/search/${keywordSlug}`,
    });
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": itemList,
  };
}
